<template>
	<BaseThemeUiLoading :class="[props.size, props.color]" />
</template>

<script setup>
const props = defineProps({
	size: String,
	color: String
})
</script>

<style scoped lang="less">
	:deep(svg){display: block; margin: auto;}
	.small{
		:deep(svg){width: 20px; height: 20px;}
	}
	.medium{
		:deep(svg){width: 30px; height: 30px;}
	}
	.white{
		:deep(svg) path{fill: #fff;}
	}
</style>